import React from "react";

const Megaphone2 = ({ color }: { color: string }) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="notify-banner-img"
    >
      <path
        d="M11.9032 14.3532L17.1565 14.15C17.9087 14.1209 18.3602 13.3026 17.9839 12.6508L13.0215 4.05574C12.6452 3.40387 11.7107 3.38581 11.3095 4.02264L8.50686 8.4705L11.9032 14.3532Z"
        fill={color}
      />
      <path
        d="M17.3631 7.27916C17.2149 7.02243 17.3028 6.69416 17.5596 6.54594L18.4907 6.00834C18.7474 5.86012 19.0757 5.94808 19.2239 6.20481C19.3722 6.46154 19.2842 6.78981 19.0275 6.93803L18.0963 7.47563C17.8396 7.62385 17.5113 7.53589 17.3631 7.27916Z"
        fill={color}
      />
      <path
        d="M16.1157 3.61655C16.2962 3.38137 16.6331 3.33701 16.8683 3.51747C17.1035 3.69792 17.1478 4.03485 16.9674 4.27003L16.3128 5.12321C16.1323 5.35843 15.7953 5.4028 15.5601 5.22231C15.325 5.04184 15.2806 4.70488 15.4611 4.46969L16.1157 3.61655Z"
        fill={color}
      />
      <path
        d="M20.3727 9.58904C20.4115 9.88297 20.2045 10.1526 19.9106 10.1913L18.8445 10.3317C18.5506 10.3704 18.281 10.1635 18.2423 9.86956C18.2036 9.57563 18.4105 9.30598 18.7044 9.26728L19.7705 9.12692C20.0644 9.08822 20.334 9.29512 20.3727 9.58904Z"
        fill={color}
      />
      <path
        d="M7.7535 9.31301L4.62694 11.1181C4.11308 11.4148 3.93703 12.0719 4.2337 12.5857L4.07827 12.6755C3.13793 13.2184 2.81457 14.4251 3.35748 15.3655C3.90039 16.3058 5.10715 16.6292 6.04749 16.0863L6.20292 15.9965C6.49964 16.5104 7.15678 16.6865 7.67071 16.3898L7.78111 16.3261L12.461 20.4322C12.9893 20.8957 13.7541 20.9711 14.3627 20.6198C15.34 20.0555 15.4687 18.6958 14.6147 17.9582L10.8852 14.7373L7.7535 9.31301Z"
        fill={color}
      />
    </svg>
  );
};
export default Megaphone2;
